import { OFFLINE_STEPS_DATABASE_NAME_PREFIX } from '../stepsDatabase';

export function clearOfflineStepsDatabases(): void {
	if ('indexedDB' in window && indexedDB.databases) {
		void indexedDB.databases().then((databases) => {
			const offlineStepsDatabases = databases.filter(
				(db) => db.name && db.name.startsWith(OFFLINE_STEPS_DATABASE_NAME_PREFIX),
			);

			offlineStepsDatabases.forEach((db) => {
				if (!db.name) {
					return;
				}

				const openReq = indexedDB.open(db.name);
				openReq.onsuccess = (event) => {
					const req = event.target as IDBOpenDBRequest;
					const idb = req.result;
					try {
						const tx = idb.transaction(['steps', 'meta'], 'readwrite');
						tx.objectStore('steps').clear();
						tx.objectStore('meta').clear();
						tx.oncomplete = () => {
							idb.close();
						};
						tx.onerror = () => {
							idb.close();
						};
					} catch {
						idb.close();
					}
				};
			});
		});
	}
}
